import { render } from "./ClientDeauthorizeModal.vue?vue&type=template&id=10f3cd22"
import script from "./ClientDeauthorizeModal.vue?vue&type=script&lang=js"
export * from "./ClientDeauthorizeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__